import React, { FormEvent } from 'react';
import { IonList } from '@ionic/react';
import Message, { MessageId } from '../Message/Message';
import Button from '../Button/Button';

interface IFormProps {
  onSubmit: (e: FormEvent) => void;
  submitMessage: MessageId;
  children: React.ReactNode;
  className?: string;
}

export default function Form({
  onSubmit,
  children,
  className,
  submitMessage,
}: IFormProps) {
  return (
    <form onSubmit={onSubmit} className={className} role="form">
      <IonList>{children}</IonList>
      <Button fullWidth isSubmit className="ion-margin-top">
        <Message id={submitMessage} />
      </Button>
    </form>
  );
}
